module.exports = __webpack_public_path__ + "img/leelee_te.8ab69787.png";